import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import AddQuickInquiryForm from './AddQuickInquiryForm';
import { AddQuickInquiryFormValues } from 'src/models/QuickInqury.model';
import moment from 'moment';
import { showToast } from 'src/utils/showToaster';
import { useAddInquiryMutation } from 'src/services/InquiryServices';

type Props = {
  onClose: () => void;
};

const AddQuicknquryFormWrapper = ({ onClose }: Props) => {

  const [addInquiryForm] = useAddInquiryMutation();

  // Form Initial Values
  const initialValues: AddQuickInquiryFormValues = {
    name: '',
    inquiryLabel:'',
    email: '',
    mobile: '',
    summary: '',
    next_followUp_required: '',
    contact_them: '',
    next_followUp_date: '',
    next_followup_time: '',
    new_batch_start:false,
    next_followup_reason: '',
    followup_batch_start_course: [],
    disposition_one: '',
    disposition_two: '',
    inquiryType: ''
  };


  // Validation Schema
  const validationSchema = object().shape({
    name: string().required('please enter name'),
    email: string().email(),
    mobile: string().required('please enter mobile'),
    summary: string().required('please enter summary'),
    inquiryLabel : object().required('please select Inquiry Label'),
    inquiryType: object().required('please select Inquiry type'),

    disposition_one: string().required('please select disposition one'),
    disposition_two: string().required('please select disposition two'),
    next_followUp_required: string().required('Please select next followup is required'),
    contact_them: string().test(
      "address-test",
      "this field  is required",
      (value, context) => {
        const { next_followUp_required } = context.parent;
        if (next_followUp_required === "YES" && !value) {
          return false;
        }
        return true;
      }
    ),
    next_followUp_date: string().test(
      "address-test",
      "this field  is required",
      (value, context) => {
        const { contact_them } = context.parent;
        if (contact_them === "ON_DATE" && !value) {
          return false;
        }
        return true;
      }
    ),
    next_followup_time: string().test(
      "address-test",
      "this field  is required",
      (value, context) => {
        const { contact_them } = context.parent;
        if (contact_them === "ON_DATE" && !value) {
          return false;
        }
        return true;
      }
    ),
    // followup_batch_start_course: array().of(object({}))
    //   .test(
    //   "address-test",
    //   "this field  is required",
    //   (value, context) => {
    //     const { contact_them } = context.parent;
    //     if (contact_them === "ON_EVENT" && !value) {
    //       return false;
    //     }
    //     return true;
    //   }
    // ),
    // next_followup_reason
    next_followup_reason: string().test(
      "address-test",
      "this field  is required",
      (value, context) => {
        const { next_followUp_required } = context.parent;
        if (next_followUp_required === "NO" && !value) {
          return false;
        }
        return true;
      }
    ),
  });

  // Handle Submit
  const handleSubmit = (
    values: AddQuickInquiryFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AddQuickInquiryFormValues>
  ) => { 
    const formattedValues: any = {
      mobile: values?.mobile,
      name: values?.name,
      email: values?.email,
      inquiryType: values.inquiryType?.value,
      inquiryLabelId : values?.inquiryLabel?.value ,
      next_followUp_required: values?.next_followUp_required,
      contact_them: values?.contact_them,
      communication_summary : values?.summary || '',
      next_followUp_date: values?.next_followUp_date ?moment(values?.next_followUp_date).format('yyyy-MM-DD')  : '',
      next_followup_time:values?.next_followup_time ?  moment(values?.next_followup_time).format("hh:mm A") : '',
      new_batch_start: values?.new_batch_start  ? true : false,
      followup_batch_start_course: values?.followup_batch_start_course?.map(
        (course: any) => course.value
      ),
      next_followup_reason: values?.next_followup_reason,

      disposition_one:
        values?.disposition_one === "" ? null : values?.disposition_one,
      disposition_two:
        values?.disposition_two === "" ? null : values?.disposition_two,
    };

    addInquiryForm(formattedValues).then((res: any) => { 
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          onClose()
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='lg' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <AddQuickInquiryForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddQuicknquryFormWrapper;